module.exports = __webpack_public_path__ + "static/media/settings-icon.f5e382dd.svg";